import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchExpenditures(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/finance/expenses/", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchExpenditure(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/finance/expenses/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    editExpenditure(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/finance/expenses", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteExpenditure(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/finance/expenses", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteExpenditureItem(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/finance/expenses/item", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
   
  }
};
